import React from "react";
import styles from "./Logo.module.css";
import newestLogo from "./newest_logo-removebg-preview.png";
import nonWhiteLogo from "./non_-white_newest_logo-removebg-preview.png";

export const Logo = ({ variant = "default", className = "", ...props }) => {
  // Use non-white logo for white/sidebar variants, regular logo for default/whiteBg
  const logoSrc = (variant.includes("white") || variant.includes("sidebar")) ? nonWhiteLogo : newestLogo;
  
  // Combine variant classes
  const variantClasses = variant.split(' ').map(v => styles[v]).filter(Boolean).join(' ');
  
  return (
    <div className={`${styles.logo} ${variantClasses} ${className}`} {...props}>
      <div className={styles.logoContainer}>
        <img 
          src={logoSrc} 
          alt="Galile Logo" 
          className={styles.logoImage}
        />
      </div>
    </div>
  );
};